import { useTranslation } from "react-i18next";
import { X, Check, Hotel, Home } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";

const HotelVsGuestlyComparison = () => {
  const { t } = useTranslation();

  const hotelItems = t("corporateCalculator.comparison.hotelItems", {
    returnObjects: true,
  }) as string[];
  const guestlyItems = t("corporateCalculator.comparison.guestlyItems", {
    returnObjects: true,
  }) as string[];

  return (
    <section className="w-full py-16 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Hotel Column */}
          <ScrollReveal direction="left">
            <div className="bg-card rounded-lg border border-border p-8 shadow-sm">
              <div className="flex flex-col items-center mb-6">
                <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
                  <Hotel className="w-8 h-8 text-destructive" />
                </div>
                <h3 className="text-2xl font-bold text-foreground">
                  {t("corporateCalculator.comparison.hotelTitle")}
                </h3>
              </div>
              <ul className="space-y-4">
                {hotelItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <X className="w-5 h-5 text-destructive mt-0.5 flex-shrink-0" />
                    <span className="text-muted-foreground">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>

          {/* Guestly Homes Column */}
          <ScrollReveal direction="right">
            <div className="bg-card rounded-lg border-2 border-primary p-8 shadow-md">
              <div className="flex flex-col items-center mb-6">
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                  <Home className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-2xl font-bold text-foreground">
                  {t("corporateCalculator.comparison.guestlyTitle")}
                </h3>
              </div>
              <ul className="space-y-4">
                {guestlyItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                    <span className="text-foreground font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default HotelVsGuestlyComparison;
